<script lang="ts">
    import { formatPercent } from '../utils/format.js';

    /** Only the last name is shown; space is tight */
    export let last: string;
    /** CSS party name the styles use: 'dem' | 'gop' | 'np'... (partyClass) */
    export let  party: string;
    /** The feed's party.abbr, e.g. 'D'; empty if the choice has no party */
    export let  partyAbbr: string;
    export let votes: number;
    export let  totalVotes: number;
    export let  isWinner: boolean;
    export let  isUncontested: boolean;
    export let  idx: number;
    export let isRunoff: boolean;
    export let isIncumbent: boolean;

    $: PercentVotes = formatPercent(votes, totalVotes)

    </script>



    <td class="{(isWinner || isUncontested) ? party : 'oth'}"
        class:winner = {isWinner || isUncontested}
        class:desktop-only={idx==2}
        >
        <div class="summary-results__row-candidate">
            <span class="summary-results__row-name">
                {#if isWinner || isUncontested}
                    <span class="summary-results__candidate-winner">{'✓'}</span>
                {/if}
                {last} {#if isIncumbent}*{/if}
                <span class="summary-results__row-party">
                    {#if partyAbbr}
                    {`(${partyAbbr})`}
                    {/if}
                </span>
                {#if isRunoff}
                <span class="candidate__cell-runoff candidate__">Runoff</span>
                {/if}
            </span>
            <span class="summary-results__row-results">
                <span>{isUncontested ? '-' : PercentVotes}&nbsp;<span class="candidate__pct-symbol">%</span></span>
            </span>
        </div>
    </td>
